var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "address-saved" }, [
    !_vm.active
      ? _c("div", { staticClass: "address-info" }, [_vm._t("info")], 2)
      : _c("div", { staticClass: "address-form" }, [_vm._t("form")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }